import { useCallback } from 'react'
import AmazonSalesBanner from '../components/AmazonSalesBanner'
import CuratedPhotosHeader from '../components/CuratedPhotosHeader'
import DPFFaqJpSection from '../components/DPFFaqJpSection'
import EaseOfUseSection from '../components/EaseOfUseSection'
import EmotionalClosingSection from '../components/EmotionalClosingSection'
import Footer from '../components/Footer'
import HeroSection from '../components/HeroSection'
import MemoriesSection from '../components/MemoriesSection'
import ProductPricingSection from '../components/ProductPricingSection'
import PurchaseButtons from '../components/PurchaseButtons'
import PurchaseStepsSection from '../components/PurchaseStepsSection'
import UsageScenesSection from '../components/UsageScenesSection'
import UserVoicesSection from '../components/UserVoicesSection'
import { useAppContext } from '../contexts/AppContext'
import useTracking from '../hooks/useTracking'
import { getHeaderType } from '../utils/headerType'

export default function LandingPage() {
  const {
    isPremiumUser = false,
    userPhotos = [],
    premiumDeepLinkUrl = '',
    api,
    isAmazonSaleActive = false,
    amazonAvailable = true,
    rakutenAvailable = true,
  } = useAppContext()
  const isUsingFallback = userPhotos.length === 0
  const isAllSoldOut = !amazonAvailable && !rakutenAvailable

  const {
    logClickedBuyOnAmazon,
    logClickedBuyOnRakuten,
    logClickedLearnMoreAboutPremium,
    logClickedPurchaseStepsButtonAmazon,
    logClickedPurchaseStepsButtonRakuten,
  } = useTracking({ api: api || null })

  const handleBuyOnAmazonClick = useCallback(() => {
    logClickedBuyOnAmazon()
  }, [logClickedBuyOnAmazon])

  const handleBuyOnRakutenClick = useCallback(() => {
    logClickedBuyOnRakuten()
  }, [logClickedBuyOnRakuten])

  const showNewYearBanner = getHeaderType() === 'new-year'

  return (
    <>
      {isAllSoldOut && (
        <div className='sticky top-0 z-20 bg-mi-bg-primary py-4 text-center text-[17px] font-bold text-white leading-6'>
          ご好評につき完売いたしました！
        </div>
      )}

      {isAmazonSaleActive && <AmazonSalesBanner />}

      <header className='relative'>
        <CuratedPhotosHeader curatedPhotos={userPhotos} isUsingFallback={isUsingFallback} />
      </header>

      {showNewYearBanner && (
        <div className='bg-[#EA5153] py-3 text-center text-white flex items-center justify-center gap-2'>
          <span className='text-[#EA5153] text-[12px] leading-[154%] leading-[11%] gap-[10px] bg-white px-2 py-0.5 rounded-[40px] font-extrabold'>
            新発売
          </span>
          {'  '}
          <span className='font-bold'>2025年を家族で振り返りませんか?</span>
        </div>
      )}

      <UserVoicesSection />
      <HeroSection />
      <EaseOfUseSection />

      <ProductPricingSection
        isPremiumUser={isPremiumUser}
        premiumDeepLinkUrl={premiumDeepLinkUrl}
        logClickedLearnMoreAboutPremium={logClickedLearnMoreAboutPremium}
      />
      <PurchaseStepsSection
        logClickedPurchaseStepsButtonAmazon={logClickedPurchaseStepsButtonAmazon}
        logClickedPurchaseStepsButtonRakuten={logClickedPurchaseStepsButtonRakuten}
        isAmazonSaleActive={isAmazonSaleActive}
        amazonAvailable={amazonAvailable}
        rakutenAvailable={rakutenAvailable}
      />

      <UsageScenesSection />
      <MemoriesSection curatedPhotos={[]} isUsingFallback={true} />
      <EmotionalClosingSection />
      <DPFFaqJpSection />

      <Footer />

      <PurchaseButtons
        onAmazonClick={handleBuyOnAmazonClick}
        onRakutenClick={handleBuyOnRakutenClick}
        isAmazonSaleActive={isAmazonSaleActive}
        amazonAvailable={amazonAvailable}
        rakutenAvailable={rakutenAvailable}
      />
    </>
  )
}
